import React from 'react';
import Calendar from 'react-calendar';

import './styles.scss';

const CustomCalendar = ({ classes, value, onChange, showNeighboringMonth, activeStartDate, disabled }) => {
  return (
    <Calendar
      className={`${classes || ''}${disabled ? ' disabled' : ''}`}
      value={value}
      onChange={onChange}
      showNeighboringMonth={showNeighboringMonth}
      activeStartDate={activeStartDate}
      nextLabel={
        <div className="nav-arrow right">
          <i className={'uil uil-angle-right-b'}></i>
        </div>
      }
      prevLabel={
        <div className="nav-arrow left">
          <i className={'uil uil-angle-left-b'}></i>
        </div>
      }
    />
  );
};

export default CustomCalendar;
